import React from "react";
import PriceField from "../PriceField";
import InputWithSuggestions from "../../InputWithSuggestions";

export default function AddOnEditor({ values, onChange, categories = [] }) {

	return <div className="addOnEditor">

		<div className="flexy">
			<input
				style={{
					flex: 2,
					marginRight: 10
				}}
				type="text"
				name="name"
				placeholder="Name"
				value={values.name || ""}
				onChange={e => {
					onChange({ name: e.target.value })
				}}
			/>
			<PriceField
				style={{
					flex: 1,
					marginleft: 10
				}}
				placeholder="Price"
				value={values.price || 0}
				onChange={value => onChange({ price: value })}
			/>
		</div>

		<div>
			<InputWithSuggestions
				placeholder="Category (optional)"
				suggestions={categories}
				value={values.category || ""}
				onChange={category => onChange({ category })}
			/>
		</div>

		<textarea
			style={{ resize: "none", minHeight: 50 }}
			type="text"
			name="description"
			placeholder="Description"
			value={values.description || ""}
			onChange={e => {
				onChange({ description: e.target.value })
			}}
		/>
	</div>
}